const notNull = value => value !== null
const getCustomSalary = salary =>
  notNull(salary)
    ? parseInt(salary)?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    : '-'
const formatSalary = (salary, t) => {
  const SALARY_TEXT = {
    'No Income': t('r.profile.edit.no_income.text', 'No Income'),
    'Rent Prepay': t('r.profile.edit.prepay_rent.text', 'Prepay Rent'),
    '1-29k': t('r.profile.edit.income_1_to_29.text', '$1-$29k'),
    '30k-59k': t('r.profile.edit.income_30_to_59.text', '$30-$59k'),
    '60k-79k': t('r.profile.edit.income_60_to_79.text', '$60-$79k'),
    '80k-99k': t('r.profile.edit.income_80_to_99.text', '$80-$99k'),
    '100k-149k': t('r.profile.edit.income_100_to_149.text', '$100-$149k'),
    '150k+': t('r.profile.edit.income_150_plus.text', '$150k+')
  }
  const salaryKeys = Object.keys(SALARY_TEXT)
  return salaryKeys.includes(salary) ? SALARY_TEXT[salary] : getCustomSalary(salary)
}

export const formatSalaryRange = (salaryRange, t) => {
  const SALARY_RANGE_TEXT = {
    'No Income': t('r.profile.edit.no_income.text', 'No Income'),
    'Rent Prepay': t('r.profile.edit.prepay_rent.text', 'Prepay Rent'),
    '0-10k': t('r.profile.edit.income_0_to_10.text', '0-$10k'),
    '10k-25k': t('r.profile.edit.income_10_to_25.text', '$10k-$25k'),
    '25k-50k': t('r.profile.edit.income_25_to_50.text', '$25k-$50k'),
    '50k-75k': t('r.profile.edit.income_50_to_75.text', '$50k-$75k'),
    '75k-100k': t('r.profile.edit.income_75_to_100.text', '$75k-$100k'),
    '100k-150k': t('r.profile.edit.income_100_to_150.text', '$100k-$150k'),
    '150k-200k': t('r.profile.edit.income_150_to_200.text', '$150k-$200k'),
    '200k-250k': t('r.profile.edit.income_200_to_250.text', '$200k-$250k'),
    '250k+': t('r.profile.edit.income_250_plus.text', '$250k+')
  }
  const salaryKeys = Object.keys(SALARY_RANGE_TEXT)
  return salaryKeys.includes(salaryRange) ? SALARY_RANGE_TEXT[salaryRange] : salaryRange
}
export default formatSalary
